function Header() {
  return (
    <div className="mainHeader">
      <h1>Denziens and Districts</h1>
    </div>
  );
}

export default Header;
